import { isNotEmpty } from '@common/utils/typeGuards';
import { useBaseDelivery, useRecentEmails } from '@features/delivery';
import { useCallback, useState } from 'react';
import {
    BaseOrderPayload,
    OrderDeliveryItem,
    OrderType,
    WizardAccumulatedData,
} from '../types';
import { useServiceOrderAction } from './useServiceOrderAction';

export const useServiceOrderModal = () => {
    const { executeOrder } = useServiceOrderAction();
    const { recentEmails, addEmailsToHistory } = useRecentEmails();

    const [selectedOrderType, setSelectedOrderType] =
        useState<OrderType | null>(null);

    const { openModal, deliveryState, deliveryActions } = useBaseDelivery<
        OrderDeliveryItem,
        WizardAccumulatedData
    >({
        apiAction: async (items, payload) => {
            return await executeOrder(items, payload as BaseOrderPayload);
        },
        onSuccess: (payload) => {
            if (isNotEmpty(payload.faspexRecipient))
                addEmailsToHistory(payload.faspexRecipient);
        },
    });

    const openServiceOrder = useCallback(
        (items: OrderDeliveryItem[], type?: OrderType) => {
            if (type) setSelectedOrderType(type);
            openModal(items);
        },
        [openModal],
    );

    return {
        openServiceOrder,
        selectedOrderType,
        setSelectedOrderType,
        dialogProps: {
            ...deliveryState,
            ...deliveryActions,
            onOpenChange: deliveryActions.setIsOpen,
            suggestedEmails: recentEmails,
        },
    };
};
